import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { START_PATH } from '@/app/routes';

/** 403 for RequireRole failure (defense-in-depth; backend @PreAuthorize stays authoritative). */
export function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <div className="flex h-full items-center justify-center p-8">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>403 — Access denied</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">You don&apos;t have access to this page.</p>
          <Button onClick={() => void navigate(START_PATH)}>Back to app</Button>
        </CardContent>
      </Card>
    </div>
  );
}
